import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _pick from "lodash/pick";

var _templateObject;

var _excluded = ["ref"];
import "core-js/modules/es6.string.link.js";
import PropTypes from 'prop-types';
import React from 'react';
import { ImpressionContext, useImpression } from '@nerdwallet/analytics/react/impression';
import { gql } from '@nerdwallet/apollo';
import { getProductImpressionPayload } from './analytics';
import { PRODUCT_IMPRESSION_OVERWRITABLE_FIELDS } from './analytics/constants';
import BaseMarketplaceCta from './base-marketplace-cta';

var MarketplaceCta = function MarketplaceCta(_ref) {
  var _gqlMarketplaceEntity;

  var analyticsPayloadOverrides = _ref.analyticsPayloadOverrides,
      children = _ref.children,
      className = _ref.className,
      cta = _ref.cta,
      disableAnnotation = _ref.disableAnnotation,
      gqlMarketplaceEntity = _ref.gqlMarketplaceEntity,
      hideFederallyInsuredAnnotation = _ref.hideFederallyInsuredAnnotation,
      hideInstitutionFromAnnotation = _ref.hideInstitutionFromAnnotation,
      id = _ref.id,
      linkType = _ref.linkType,
      onClick = _ref.onClick,
      omitImpression = _ref.omitImpression,
      reviewLinkOverride = _ref.reviewLinkOverride,
      shortButton = _ref.shortButton,
      urlSearchParams = _ref.urlSearchParams,
      externalClickId = _ref.externalClickId,
      useSecondaryStyleForReviews = _ref.useSecondaryStyleForReviews,
      legacyTrkProps = _ref.legacyTrkProps,
      showIcon = _ref.showIcon,
      slug = _ref.slug;

  var _useImpression = useImpression({
    entityName: undefined,
    eventType: 'product_impression',
    payload: _objectSpread(_objectSpread({}, getProductImpressionPayload(gqlMarketplaceEntity)), {}, {
      destination_url: (cta === null || cta === void 0 ? void 0 : cta.link) || ((_gqlMarketplaceEntity = gqlMarketplaceEntity.cta) === null || _gqlMarketplaceEntity === void 0 ? void 0 : _gqlMarketplaceEntity.link)
    }, _pick(analyticsPayloadOverrides, PRODUCT_IMPRESSION_OVERWRITABLE_FIELDS)),
    refireOnEventChange: true
  }),
      ref = _useImpression.ref,
      impression = _objectWithoutProperties(_useImpression, _excluded);

  if (!(cta || gqlMarketplaceEntity.cta)) {
    return children || null;
  }

  var ctaComponent = /*#__PURE__*/React.createElement(BaseMarketplaceCta, {
    analyticsPayloadOverrides: analyticsPayloadOverrides,
    className: className,
    cta: cta,
    disableAnnotation: disableAnnotation,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    hideFederallyInsuredAnnotation: hideFederallyInsuredAnnotation,
    hideInstitutionFromAnnotation: hideInstitutionFromAnnotation,
    id: id,
    legacyTrkProps: legacyTrkProps,
    linkType: linkType,
    onClick: onClick,
    reviewLinkOverride: reviewLinkOverride,
    shortButton: shortButton,
    showIcon: showIcon,
    urlSearchParams: urlSearchParams,
    externalClickId: externalClickId,
    // TODO (REVS-112): Either remove or replace with a more permanent solution
    useSecondaryStyleForReviews: useSecondaryStyleForReviews,
    slug: slug,
    // TODO (RUR-246): The following props can be removed once we cutover to Bedrock
    logImpression: !omitImpression
  }, children);

  if (omitImpression) {
    return ctaComponent;
  }

  return /*#__PURE__*/React.createElement(ImpressionContext.Provider, {
    value: impression
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, ctaComponent));
};

if (process.env.NODE_ENV !== 'production') {
  MarketplaceCta.propTypes = _objectSpread(_objectSpread({
    omitImpression: PropTypes.bool
  }, _pick(BaseMarketplaceCta.propTypes, ['analyticsPayloadOverrides', 'children', 'className', 'cta', 'disableAnnotation', 'gqlMarketplaceEntity', 'hideFederallyInsuredAnnotation', 'hideInstitutionFromAnnotation', 'id', 'legacyTrkProps', 'linkType', 'reviewLinkOverride', 'shortButton', 'urlSearchParams', 'showIcon', 'slug'])), {}, {
    useSecondaryStyleForReviews: PropTypes.bool
  });
}

MarketplaceCta.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment MarketplaceCta on MarketplaceEntityInterface {\n    ... on MarketplaceEntityWithPlacementInterface {\n      cta {\n        link\n        ...MarketplaceCtaOnEntityPlacementCTA\n      }\n    }\n\n    ...BaseMarketplaceCta\n    ...getProductImpressionPayload\n  }\n\n  fragment MarketplaceCtaOnEntityPlacementCTA on EntityPlacementCTA {\n    link\n    ...BaseMarketplaceCtaOnEntityPlacementCTA\n  }\n\n  ", "\n  ", "\n"])), getProductImpressionPayload.fragment, BaseMarketplaceCta.fragment);
export default MarketplaceCta;